export default __webpack_public_path__ + "static/media/_DSC0181.00f58e17.JPG";